import React, { useEffect, useRef } from "react";
import "./Main.css";
import myself from "./assets/Ashwani.png";
import video1 from "./assets/video/NewsFlash.mp4";
import video2 from "./assets/video/Chat-app.mp4";
import video3 from "./assets/video/Weather.mp4";
import video4 from "./assets/video/2048-game.mp4";
import video5 from "./assets/video/Birds.mp4";
import video6 from "./assets/video/amazon.mp4";
import resume from "./assets/Ashwani.pdf";
import { useLocation } from "react-router";
import About from "./About";
import Work from "./Work";
import Research from "./Research";
import { Icon } from "@iconify/react";
import Education from "./Education";

function Main() {
  const home = useRef(null);
  const about = useRef(null);
  const work = useRef(null);
  const projects = useRef(null);
  const contact = useRef(null);
  const news = useRef(null);
  const amazon = useRef(null);
  const chat = useRef(null);
  const weather = useRef(null);
  const game = useRef(null);
  const dynamic = useRef(null);
  const research = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#home") {
      window.scrollTo(0, 0);
    }
    const hashRefs = [
      { hash: "#about", ref: about },
      { hash: "#work", ref: work },
      { hash: "#research", ref: research },
      { hash: "#projects", ref: projects },
      { hash: "#contact", ref: contact },
      { hash: "#news", ref: news },
      { hash: "#amazon", ref: amazon },
      { hash: "#chat", ref: chat },
      { hash: "#weather", ref: weather },
      { hash: "#game", ref: game },
      { hash: "#dynamic", ref: dynamic },
    ];

    const locationHash = location.hash;

    for (const { hash, ref } of hashRefs) {
      if (locationHash === hash) {
        ref.current.scrollIntoView({ behavior: "smooth" });
        break; // Exit the loop once a match is found
      }
    }
  }, [location]);

  function reveal() {
    var reveals = document.querySelectorAll(".reveal");

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 120;

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  }

  // Listening to the video element
  const clip = document.querySelectorAll(".file");
  for (let i = 0; i < clip.length; i++) {
    /* Adding the event listeners on the video to play/pause the video. */
    if (clip) {
      clip[i].addEventListener("mouseover", function (e) {
        clip[i].play();
      });
    }

    /* Applying the mouse out event to pause the video */
    if (clip) {
      clip[i].addEventListener("mouseout", function (e) {
        clip[i].pause();
      });
    }
  }
  const clip_1 = document.querySelectorAll(".file-1");
  for (let i = 0; i < clip_1.length; i++) {
    /* Adding the event listeners on the video to play/pause the video. */
    if (clip_1) {
      clip_1[i].addEventListener("mouseover", function (e) {
        clip_1[i].play();
      });
    }

    /* Applying the mouse out event to pause the video */
    if (clip_1) {
      clip_1[i].addEventListener("mouseout", function (e) {
        clip_1[i].pause();
      });
    }
  }
  window.addEventListener("scroll", reveal);

  // Connecting to google sheets
  const scriptURL =
    "https://script.google.com/macros/s/AKfycbz1RKTvWhBQKCv_by9DaBoblfVtZOlvnP4LBQQUqcZEtQBoqwWSxDGALxAE65HOyIyF/exec";
  const form = document.forms["submit-to-google-sheet"];
  const msg = document.getElementById("msg");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      fetch(scriptURL, { method: "POST", body: new FormData(form) })
        .then((response) => {
          msg.innerHTML = "Message sent successfully";
          setTimeout(function () {
            msg.innerHTML = "";
          }, 2000);
          form.reset();
        })
        .catch((error) => console.error("Error!", error.message));
    });
  }
  return (
    <div id="home" ref={home}>
      <div style={{ margin: "5%" }}>
        <div className="hero">
          <div className="hero__title">
            <div className="hero__p">
              <br />
              Hey There, I am <br />
              <h1 className="heading__logo">
                <span className="heading__logo1">A</span>SHWANI{" "}
                <span className="heading__logo1">V</span>ERMA.
              </h1>
            </div>
            <div className="social-icons" id="about" ref={about}>
              <a href="https://github.com/Ashwani-Verma-07">
                <i className="fa-brands fa-github"></i>
              </a>
              <a href="mailto:ashverma017@gmail.com">
                <i className="fa-regular fa-envelope"></i>
              </a>

              <a href="https://www.linkedin.com/in/ashwani-verma-64953820a/">
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://www.instagram.com/ashwani017/">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/ashwani.verma.18062533/">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="https://t.me/verma_ashwani_007">
                <i className="fa-brands fa-telegram"></i>
              </a>
            </div>
          </div>
        </div>
        <br />

        <img src={myself} className="image" alt="" />
        <div id="describe">
          <br />
          <br />
          As an aspiring software developer, I am well-versed in data structures
          and algorithms. I'm passionate about staying up to date on new
          technological developments and I'm constantly keen to learn more.
          Also, I do best in team settings where I can collaborate with a
          diverse group of motivated people from various industries.
          <br />
          <br />
          When I'm not coding, or developing some site, you'll find me doing{" "}
          <a
            href="https://drive.google.com/drive/folders/1U_SY1UQiRYPK9DF8vqbMpKVDDmkvNa5J"
            style={{ textDecoration: "none", color: "rgb(243, 201, 85)" }}
          >
            photography
          </a>
          , drawing or gaming.
        </div>

        <div className="reveal">
          <div className="skills">
            <h2>Skills:</h2>

            <div className="rows">
              <div className="columns">
                <h4>
                  <div className="symbol">
                    <i className="fas fa-check-circle" aria-hidden="true"></i>{" "}
                    HTML
                  </div>
                </h4>
                <br />
                <h4>
                  <div className="symbol">
                    <i className="fas fa-check-circle" aria-hidden="true"></i>{" "}
                    CSS
                  </div>
                </h4>
                <br />

                <h4>
                  <div className="symbol">
                    <i className="fas fa-check-circle" aria-hidden="true"></i>{" "}
                    JavaScript
                  </div>
                </h4>
              </div>
              <div className="columns">
                <h4>
                  <div className="symbol">
                    <i className="fas fa-check-circle" aria-hidden="true"></i>{" "}
                    React
                  </div>
                </h4>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div className="reveal">
          <About />
        </div>
        <div className="reveal line" />
        <div className="education">
          <div className="reveal">
            <h1>Education</h1>
            <Education />
          </div>
        </div>
        <div className="reveal line" id="work" ref={work} />
        <div className="reveal">
          <h1>Work Experience</h1>
          <br />
          <div className="work-center">
            <img
              src="https://i.ibb.co/PCqCkZ2/apple-icon-152x152.png"
              style={{ width: "30px", height: "30px" }}
              alt=""
            ></img>
            <h3>Eos World</h3>
            <h4>
              <Icon icon="clarity:date-solid" color="white" /> April 2023 - May
              2023
            </h4>
          </div>
          <Work />
        </div>
        <div className="reveal line" id="research" ref={research} />
        <div className="research">
          <h1 style={{ marginBottom: "5%" }} className="reveal">
            Research & Patents
          </h1>
          <Research />
        </div>
        <div className="reveal line" id="projects" ref={projects} />
        <div className="projects">
          <h1 style={{ marginBottom: "5%" }} className="reveal">
            My Coding Projects
          </h1>
          <div className="reveal" id="amazon" ref={amazon}>
            <video
              controls={false}
              src={video6}
              type="video/mp4"
              muted
              className="file-1"
              loop
              autoPlay
              playsInline
            ></video>
            <h2>Amazon Clone</h2>
            <p className="con">
              Users can create accounts or sign in securely with email and this
              information is stored with Google Firebase. We can Add, adjust
              quantities, and remove items easily in the products cart section.
              Separate section for Green products for a sustainable shopping
              experience.
              <br />
              <br />{" "}
              <a
                href="https://github.com/Ashwani-Verma-07/amazon-clone"
                style={{ color: "white", textDecoration: "none" }}
              >
                🔗GitHub Repo
              </a>
              <br />
              <br />
              ✔️React-Js ✔️HTML/CSS ✔️Firebase ✔️Mateial-UI
              <br />
              <br />
              <button
                className="Button-1"
                onClick={() => {
                  window.open("https://amazon-clone-6e4e3.netlify.app/");
                }}
              >
                View Live
              </button>
            </p>
            <br />
          </div>
          <div className="reveal" id="news" ref={news}>
            <video
              src={video1}
              // onMouseOut={() => {
              //   // this.pause();
              //   currentTime = 0;
              // }}
              type="video/mp4"
              muted
              className="file"
              loop
              autoPlay
              playsInline
              controls={false}
            ></video>
            <h2>News Application</h2>
            <p className="con">
              This NewsFlash application will display the latest news articles
              which are verified and approved by NewsAPI. Users can browse news
              articles through various categories and get all details in the
              read more section. This ensures an infinite scroll till all
              outcomes are exhausted.
              <br />
              <br />{" "}
              <a
                href="https://github.com/Ashwani-Verma-07/NewsFlash-App"
                style={{ color: "white", textDecoration: "none" }}
              >
                🔗GitHub Repo
              </a>
              <br />
              <br />
              ✔️React-Js ✔️HTML/CSS ✔️Bootstrap ✔️API
              <br />
              <br />
              <button
                onClick={() => {
                  window.open(
                    "https://drive.google.com/file/d/1jqxiY5S3_Ovo6519-DhHmtLadFY_anM7/view?usp=share_link"
                  );
                }}
                className="Button-1"
              >
                View Live
              </button>
            </p>
            <br />
          </div>
          <div className="reveal" id="chat" ref={chat}>
            <video
              controls={false}
              src={video2}
              type="video/mp4"
              muted
              className="file-1"
              loop
              autoPlay
              playsInline
            ></video>
            <h2>Chat Application</h2>
            <p className="con">
              This Chatting app allows you to communicate with others through
              chat. It enables you to send and receive messages. It connects
              with the google firebase authentication and sends messages to
              people who are connected to the same server. Spamming or writing
              any abusive language will permanently block you.
              <br />
              <br />{" "}
              <a
                href="https://github.com/Ashwani-Verma-07/Chat-Application"
                style={{ color: "white", textDecoration: "none" }}
              >
                🔗GitHub Repo
              </a>
              <br />
              <br />
              ✔️React-Js&nbsp;&nbsp; ✔️HTML/CSS&nbsp;&nbsp; ✔️Firebase
              <br />
              <br />
              <button
                className="Button-1"
                onClick={() => {
                  window.open("https://chat-application-07.netlify.app/");
                }}
              >
                View Live
              </button>
            </p>
            <br />
          </div>
          <div className="reveal" id="weather" ref={weather}>
            <video
              controls={false}
              src={video3}
              type="video/mp4"
              muted
              className="file"
              loop
              autoPlay
              playsInline
            ></video>
            <h2>Weather-App</h2>
            <p className="con">
              Make a Weather API frontend project that gives information about
              any city's current temperature using OpenWeatherMap API that
              allows weather data to be queried from scripts and code. It
              displays weather, temperature, and humidity as a card or asks for
              device geo-location to get the data.
              <br />
              <br />{" "}
              <a
                href="https://github.com/Ashwani-Verma-07/Weather-App"
                style={{ color: "white", textDecoration: "none" }}
              >
                🔗GitHub Repo
              </a>
              <br />
              <br />
              ✔️HTML/CSS&nbsp;&nbsp;✔️JavaScript&nbsp;&nbsp;✔️API
              <br />
              <br />
              <button
                className="Button-1"
                onClick={() => {
                  window.open("https://weather-e94fb.web.app/");
                }}
              >
                View Live
              </button>
            </p>
            <br />
          </div>
          <div className="reveal" id="game" ref={game}>
            <video
              src={video4}
              type="video/mp4"
              muted
              controls={false}
              className="file-1"
              loop
              autoPlay
              playsInline
            ></video>
            <h2>2048-Game</h2>
            <p className="con">
              In a plain 4x4 grid, Every turn, new number randomly appears in an
              empty spot with a value of either 2 or 4. Tiles with the same
              number merge when they touch. Add them up to reach 2048! If all
              tiles are occupied then you LOSE. The Highest score is stored in
              the local storage of the device.
              <br />
              <br />{" "}
              <a
                href="https://github.com/Ashwani-Verma-07/2048-game"
                style={{ color: "white", textDecoration: "none" }}
              >
                🔗GitHub Repo
              </a>
              <br />
              <br />
              ✔️HTML/CSS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✔️JavaScript
              <br />
              <br />
              <button
                className="Button-1"
                onClick={() => {
                  window.open("https://ashwani-verma-07.github.io/2048-game/");
                }}
              >
                View Live
              </button>
            </p>
            <br />
          </div>
          <div className="reveal" id="dynamic" ref={dynamic}>
            <video
              controls={false}
              src={video5}
              type="video/mp4"
              muted
              className="file"
              loop
              autoPlay
              playsInline
            ></video>
            <h2>Dynamic-Site</h2>
            <p className="con">
              The site highlights the electromagnetic effects on the diversity
              of birds by the mobile towers and their electromagnetic radiating
              objects like Cell phones. The data entered by the user is stored
              in google sheets and the location is given by a map. The State of
              India's Birds report tells about this cause.
              <br />
              <br />{" "}
              <a
                href="https://github.com/Ashwani-Verma-07/mini-project"
                style={{ color: "white", textDecoration: "none" }}
              >
                🔗GitHub Repo
              </a>
              <br />
              <br />
              ✔️HTML/CSS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✔️JavaScript
              <br />
              <br />
              <button
                className="Button-1"
                onClick={() => {
                  window.open(
                    "https://ashwani-verma-07.github.io/mini-project/"
                  );
                }}
              >
                View Live
              </button>
            </p>
            <br />
          </div>

          <div className="reveal line" id="contact" ref={contact} />

          <div className="reveal">
            <section>
              <h1 style={{ fontSize: "3.6rem" }}>Contact Me</h1>
              <div className="container">
                <div className="row">
                  <div className="contact-left">
                    <div className="icons-info">
                      <p>
                        {" "}
                        <a
                          href="mailto:ashverma017@gmail.com"
                          style={{
                            textDecoration: "none",
                            color: "rgb(231, 229, 229)",
                          }}
                        >
                          <i className="fa-solid fa-envelope"></i>
                          ashverma017@gmail.com{" "}
                        </a>
                      </p>
                      <p>
                        {" "}
                        <i className="fas fa-mobile-alt"></i>+91-9205913782
                      </p>

                      <p>
                        {" "}
                        <i className="fa-solid fa-location-dot"></i>Ghaziabad -
                        UttarPradesh - India
                      </p>
                    </div>

                    <a href={resume} download className="btn btn2">
                      Download Resume
                    </a>
                  </div>
                  <div className="contact-right">
                    <form name="submit-to-google-sheet">
                      <input
                        type="text"
                        name="Name"
                        placeholder="Your Name"
                        required
                      />
                      <input
                        type="email"
                        name="Email"
                        placeholder="Your Email"
                        required
                      />
                      <textarea
                        name="Message"
                        rows="6"
                        placeholder="Your Message"
                        required
                      ></textarea>
                      <button type="Submit" className="btn btn2">
                        Submit
                      </button>
                    </form>
                    <span id="msg"></span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
